export default "__VITE_ASSET__PL44Iiuu__"